<template>
  <div id="user-accounts-table">
    <v-data-table
      :items="data"
      :headers="headers"
      :loading="isLoading"
      class="body-2"
      :options="pagination"
      :footer-props="footerProps"
      :no-data-text="$dictionary.app.common.accounts.noData"
      :loading-text="$dictionary.app.common.accounts.loading"
    >
      <template #item.created_at="{item}">
        <table-matrics-row :text="formatDate(item.created_at)" />
      </template>
      <template #item.updated_at="{item}">
        <table-matrics-row :text="formatDate(item.updated_at)" />
      </template>
      <template #item.role="{item}">
        <table-matrics-row :text="capitalize(item.role)" />
      </template>

      <template #item.account_name="{item}">
        <table-matrics-row
          isLink
          isTextPointer
          text-class="blue--text"
          :text="item.account_name"
          :query="{ active_tab: 'profile' }"
          :navigateTo="`${$paths.accounts}/${item.id}`"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { capitalize } from "@/filters";
import { TableMatricsRow } from "@/components/shared";
import { userAccountsHeaders as headers } from "@/data/table-headers";

import { PaginationSortMixin } from "@/mixins";

/**
 * User accounts table listing
 */
export default {
  name: "UserAccountsTable",
  /**
   * ---------------- Custom events ------------------
   */
  emits: ["account-selected"],
  /**
   * ---------------- Mixins ------------------
   */
  mixins: [PaginationSortMixin],
  /**
   * ---------------- Props ------------------
   */
  props: {
    /**
     * Users list {Array}
     */
    data: { type: Array, required: true, default: () => [] },
    /**
     * Show loader in table
     */
    isLoading: { type: Boolean, required: true, default: false },
    /**
     * Default sort order of users table
     */
    defaultSortOrder: { type: String, required: true, default: "" },
  },
  /**
  |--------------------------------------------------
  | Data Properties
  |--------------------------------------------------
  */
  data() {
    return {
      headers,
    };
  },
  /**
   * ---------------- Components ------------------
   */
  components: {
    TableMatricsRow,
  },
  /**
   * ---------------- Methods ------------------
   */
  methods: {
    capitalize,
    /**
     * Formats date to am and pm format
     */
    formatDate(date) {
      const { formatDateToAmPm } = this.$options.filters;
      return formatDateToAmPm(date);
    },
    /**
     * Emits custom event in parent component to fetch the latest records
     * @emits get-records Emits this event in the parent component
     */
    getRecords() {
      this.$emit("get-records");
    },
  },
  /**
  |--------------------------------------------------
  | Created lifecycle hook
  |--------------------------------------------------
  */
  created() {
    this.disablePaginationWatcher = true;
    this.getRecords();
  },
};
</script>
